export default "__VITE_ASSET__9NacEEYU__"